import { render } from "./TheMobile.vue?vue&type=template&id=dc4fb962&scoped=true"
import script from "./TheMobile.vue?vue&type=script&lang=js"
export * from "./TheMobile.vue?vue&type=script&lang=js"

import "./TheMobile.vue?vue&type=style&index=0&id=dc4fb962&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4fb962"]])

export default __exports__